import { gql, TypedDocumentNode } from '@apollo/client'
import { committeeFragment } from './CommitteeFragment'
import { functionCodeFragment } from './FunctionCodeFragment'
import type { OfferFragment } from './__generated__/OfferFragment'

export const offerFragment: TypedDocumentNode<OfferFragment> = gql`
  ${committeeFragment}
  ${functionCodeFragment}

  fragment OfferFragment on Offer {
    committees {
      ...CommitteeFragment
    }
    connexysId
    dayContractsAllowed
    dimonaCoefficient
    dimonaEnabled
    functionCodes {
      ...FunctionCodeFragment
    }
    id
    name
    pdfUrl
    validUntil
    vivaldisOffice
  }
`
